import { useState } from 'react'
import { useSport } from '@/hooks/useSport'
import { useApi } from '@/hooks/useApi'
import { fetchNews } from '@/lib/api'
import { NewsCard } from '@/components/NewsCard'
import { Skeleton } from '@/components/ui/Skeleton'
import { FilterButtonGroup } from '@/components/ui/FilterButtonGroup'

const FILTERS = [
  { label: 'All', value: '' },
  { label: 'ESPN', value: 'espn' },
]

export default function NewsPage() {
  const { sport, sportLabel } = useSport()
  const [source, setSource] = useState('')

  const news = useApi(
    () => fetchNews(sport, source || undefined).then(d => d.news_articles || []),
    [sport, source],
  )

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-white">{sportLabel} Soccer News</h1>
          <p className="text-sm text-slate-400 mt-1">Latest college soccer news and analysis</p>
        </div>
        <FilterButtonGroup options={FILTERS} value={source} onChange={setSource} />
      </div>

      {news.loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} variant="card" className="h-64" />
          ))}
        </div>
      ) : (news.data || []).length === 0 ? (
        <div className="card p-12 text-center">
          <p className="text-slate-400">No news articles yet. Check back soon.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {(news.data || []).map((article) => (
            <NewsCard key={article.id} article={article} sport={sport} />
          ))}
        </div>
      )}
    </div>
  )
}
